// Small editorial US flag icon — subtle, luxury-toned. Two-color version keeps the
// dark-mode aesthetic (no bright primary red/blue).
export function UsFlag({ size = 18, muted = true }) {
  // Muted palette to match champagne / matte-black brand
  const red   = muted ? "#8A2B2E" : "#B22234";
  const navy  = muted ? "#1A2340" : "#3C3B6E";
  const cream = muted ? "#EDE6D2" : "#FFFFFF";

  const w = size;
  const h = Math.round(size * 0.62); // classic US flag ratio 1.9:1 → we use 1.6:1 for compact rendering

  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 38 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="American flag — Veteran Owned"
      role="img"
      style={{ display: "inline-block", verticalAlign: "middle" }}
    >
      <defs>
        <clipPath id="flagRound">
          <rect x="0" y="0" width="38" height="24" rx="1.5" ry="1.5" />
        </clipPath>
      </defs>
      <g clipPath="url(#flagRound)">
        {/* 13 stripes */}
        {Array.from({ length: 13 }).map((_, i) => (
          <rect
            key={i}
            x="0"
            y={(i * 24) / 13}
            width="38"
            height={24 / 13 + 0.1}
            fill={i % 2 === 0 ? red : cream}
          />
        ))}
        {/* Union / canton */}
        <rect x="0" y="0" width="15" height={(24 / 13) * 7} fill={navy} />
        {/* Star field — 9 tiny dots (stylized 5 stars, simplified for tiny render) */}
        {[
          [2.5, 1.8], [5.5, 1.8], [8.5, 1.8], [11.5, 1.8],
          [4, 3.6], [7, 3.6], [10, 3.6],
          [2.5, 5.4], [5.5, 5.4], [8.5, 5.4], [11.5, 5.4],
          [4, 7.2], [7, 7.2], [10, 7.2],
          [2.5, 9], [5.5, 9], [8.5, 9], [11.5, 9],
          [4, 10.8], [7, 10.8], [10, 10.8],
        ].map(([cx, cy], idx) => (
          <circle key={idx} cx={cx} cy={cy} r={0.55} fill={cream} />
        ))}
      </g>
      {/* Subtle border for definition */}
      <rect x="0.25" y="0.25" width="37.5" height="23.5" rx="1.5" fill="none" stroke="rgba(198,168,124,0.35)" strokeWidth="0.4" />
    </svg>
  );
}

export default UsFlag;
